import { NpsSurveyComponent } from '@aca-new/app/pages/book/pages/confirmation/shared/components/nps-survey/nps-survey.component';
import { ENpsSurveySource } from '@aca-new/app/pages/book/pages/confirmation/shared/components/nps-survey/shaerd/enums/nps-survey-source.enum';
import { DialogService } from '@aca-new/app/shared/components/modal/shared/services/dialog.service';
import { SurveyVisibilityService } from '@aca-new/app/shared/services/survey-visibility/survey-visibility.service';
import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
@UntilDestroy()
export class NpsSurveyService {
  public constructor(
    private readonly _dialog: DialogService,
    private readonly _surveyVisibilityService: SurveyVisibilityService
  ) {}

  public getIsSurveyVisible$(): Observable<boolean> {
    return this._surveyVisibilityService.getIsSurveyVisible$();
  }

  public tryToOpenNpsDialog(orderNo: string, serviceType: string, npsFrom: ENpsSurveySource): void {
    this.getIsSurveyVisible$()
      .pipe(untilDestroyed(this))
      .subscribe((canOpen: boolean): void => {
        if (!canOpen) {
          return;
        }

        this._dialog.open(NpsSurveyComponent, {
          data: { orderNo, serviceType, npsFrom },
          stopCloseWhenClickBackdrop: true,
        });
      });
  }
}
